<template>
  <div :class="['results']">
    <div :class="['img']"></div>
    <div class="title">Your Results</div>
    <div class="correct-text">{{correct}}/8</div>
    <div class="complete-container">
      <div class="complete-btn" @click="complete">Complete Activity</div>
    </div>
    <div class="play-again" @click="complete">Play Again</div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "intro",
  props: { correct: Number },
  data() {
    return {
      pageIndex: 0
    };
  },
  computed: {},
  methods: {
    complete() {
      window.location.reload();
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.results {
  width: 85%;
  // height: 60%;
  max-height: 332px;
  position: relative;
  max-width: 450px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px #0000001a;
  overflow: hidden;
  transition: all 0.5s linear 0s;
  -webkit-transition: all 0.5s linear 0s;
}

.img {
  width: 100%;
  margin-top: 35px;
  height: 80px;
  background-image: url("~@/assets/img/checkmark_icon.svg?external");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.title {
  font-family: "VW Head";
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.correct-text {
  font-family: "VW Head";
  font-weight: 300;
  width: 100%;
  text-align: center;
  margin-top: 15px;
}

.complete-container {
  width: 100%;
  height: 40px;
  margin-top: 15px;
}

.complete-btn {
  width: 80%;
  max-width: 193px;
  margin: 0 auto;
  background-color: rgba(0, 176, 240, 1);
  height: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: "VW Text";
  font-weight: normal;
}

.complete-btn:hover {
  background-color: rgba(0, 176, 240, 0.8);
}

.complete-btn:active {
  background-color: rgba(0, 176, 240, 0.5);
}

.play-again {
  font-family: "VW Text";
  font-weight: bold;
  width: 100%;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 30px;
  color: #00b0f0;
  font-size: 0.7rem;
  cursor: pointer;
}
</style>